// src/components/StorekeeperDashboard.js
import React, { useState } from 'react';
import axiosInstance from '../axiosConfig';
import { buildMediaUrl } from '../apiConfig';
import { Modal, Button } from 'react-bootstrap';
import './StorekeeperDashboard.css'

function StorekeeperDashboard({ orders, onOrderIssued }) {
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [expandedItems, setExpandedItems] = useState({});
    const [showImageModal, setShowImageModal] = useState(false);
    const [modalImageSrc, setModalImageSrc] = useState('');

    // Получение деталей заказа по cartId и имени пользователя
    const fetchOrderDetails = (cartId, user, statusLabel) => {
        axiosInstance.get(`/api/cart/${cartId}/`)
            .then(response => {
                const orderDetails = response.data;
                setSelectedOrder({
                    cartId: cartId,
                    message: `Заказ #${cartId}`,
                    details: orderDetails,
                    status: orderDetails.status_label || statusLabel || 'Статус не указан',
                    user: orderDetails.user || user
                });
            })
            .catch(error => {
                console.error('Error fetching order details:', error);
                window.Toastify({
                    text: "Ошибка при загрузке деталей заказа.",
                    duration: 3000,
                    gravity: "top",
                    position: "right",
                    backgroundColor: "#ff0000"
                }).showToast();
            });
    };

    // Показать уведомление пользователю
    const showUserNotification = (userName) => {
        window.Toastify({
            text: `Уведомление: Заказ для ${userName} успешно выдан.`,
            duration: 3000,
            gravity: "top",
            position: "right",
            backgroundColor: "linear-gradient(to right, #28a745, #218838)",
            stopOnFocus: true,
            close: true,
        }).showToast();
    };

    // Обработчик завершения заказа
    const handleCompleteOrder = (cartId, issuedTo) => {
        axiosInstance.post(`/api/cart/${cartId}/issue/`, { issued_to: issuedTo })
            .then(response => {
                if (response.data.success) {
                    console.log('Order issued successfully');
                    showUserNotification(issuedTo);  // Показать уведомление пользователю
                    setSelectedOrder(null);
                    onOrderIssued(cartId);
                } else {
                    console.error('Error issuing order:', response.data.errors);
                    window.Toastify({
                        text: `Ошибка: ${response.data.errors.join(', ')}`,
                        duration: 3000,
                        gravity: "top",
                        position: "right",
                        backgroundColor: "#ff0000"
                    }).showToast();
                }
            })
            .catch(error => {
                console.error('Error issuing order:', error);
                window.Toastify({
                    text: "Ошибка при выдаче заказа.",
                    duration: 3000,
                    gravity: "top",
                    position: "right",
                    backgroundColor: "#ff0000"
                }).showToast();
            });
    };

    // Обработчик удаления заказа
    const handleDeleteOrder = (cartId) => {
        if (window.confirm('Вы уверены, что хотите удалить этот заказ?')) {
            axiosInstance.delete(`/api/cart/${cartId}/delete/`)
                .then(response => {
                    if (response.data.success) {
                        console.log('Order deleted successfully');
                        setSelectedOrder(null);
                        onOrderIssued(cartId);
                        window.Toastify({
                            text: "Заказ успешно удалён.",
                            duration: 3000,
                            gravity: "top",
                            position: "right",
                            backgroundColor: "#00b09b"
                        }).showToast();
                    } else {
                        console.error('Error deleting order:', response.data.errors);
                        window.Toastify({
                            text: `Ошибка: ${response.data.errors.join(', ')}`,
                            duration: 3000,
                            gravity: "top",
                            position: "right",
                            backgroundColor: "#ff0000"
                        }).showToast();
                    }
                })
                .catch(error => {
                    console.error('Error deleting order:', error);
                    window.Toastify({
                        text: "Ошибка при удалении заказа.",
                        duration: 3000,
                        gravity: "top",
                        position: "right",
                        backgroundColor: "#ff0000"
                    }).showToast();
                });
        }
    };

    // Переключение состояния расширения элемента
    const toggleItemExpansion = (index) => {
        setExpandedItems(prevState => ({
            ...prevState,
            [index]: !prevState[index]
        }));
    };

    // Обработчик клика по изображению для показа в модальном окне
    const handleImageClick = (imageSrc) => {
        setModalImageSrc(imageSrc);
        setShowImageModal(true);
    };

    return (
        <div className="container mt-4 dashboard">
            <h1>Dashboard кладовщика</h1>
            {selectedOrder ? (
                <div className="mb-3 dashboard-order-panel">
                    <div className="card-body cart-componetn dashboard-order-shell">
                        <div className="dashboard-order-meta">
                            <h5 className="card-title">{selectedOrder.message}</h5>
                            <p className="card-text">Статус: {selectedOrder.status}</p>
                            <h6>Детали заказа:</h6>
                            <p className="card-text">Пользователь: {selectedOrder.user}</p>
                            {selectedOrder.details.requires_rtcsd_ticket && (
                                <div className="mb-3">
                                    {selectedOrder.details.rtcsd_is_cassette ? (
                                        <p className="card-text mb-1"><strong>Hyosung:</strong> кассета, RT CSD феномен не создается</p>
                                    ) : (
                                        <>
                                            <p className="card-text mb-1"><strong>RT CSD заявка:</strong> {selectedOrder.details.rtcsd_ticket_number || 'Не указана'}</p>
                                            <p className="card-text mb-1"><strong>Серийный номер:</strong> {selectedOrder.details.rtcsd_device_serial || 'Не указан'}</p>
                                        </>
                                    )}
                                    {selectedOrder.details.rtcsd_status && (
                                        <p className="card-text mb-0"><strong>RT CSD статус:</strong> {selectedOrder.details.rtcsd_status}</p>
                                    )}
                                </div>
                            )}
                        </div>
                        <ul className="list-group dashboard-order-list">
                            {selectedOrder.details.items.map((item, idx) => (
                                <li key={item.id ? `item-${item.id}` : `item-${idx}`} className="list-group-item dashboard-order-item">
                                    <div className="d-flex justify-content-between align-items-center dashboard-order-item-row">
                                        <div
                                            className="dashboard-order-item-main"
                                            onClick={() => toggleItemExpansion(idx)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            {item.photo && (
                                                <div 
                                                    className="image-container dashboard-order-item-image" 
                                                    onClick={() => handleImageClick(buildMediaUrl(item.photo))} 
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <img 
                                                        src={buildMediaUrl(item.photo)} 
                                                        alt={item.component} 
                                                        className="img-thumbnail" 
                                                        style={{ width: '50px' }} 
                                                    />
                                                </div>
                                            )}
                                            <div className="dashboard-order-item-text">
                                                <span className="dashboard-order-item-name">{item.component}</span>
                                                <small className="dashboard-order-item-location">
                                                    <span className="dashboard-order-item-location-label">Место хранения</span>
                                                    <strong className="dashboard-order-item-location-value">{item.storage_location || 'Не указано'}</strong>
                                                </small>
                                            </div>
                                        </div>
                                        <span className="dashboard-order-item-qty" style={{ cursor: 'pointer' }}>{item.quantity} шт.</span>
                                    </div>
                                    {expandedItems[idx] && (
                                        <div className="mt-2 dash text-dark dashboard-order-detail-panel">
                                            <p><strong>Описание:</strong> {item.description}</p>
                                            <p><strong>Количество на складе:</strong> {item.stock_quantity}</p>
                                            <p><strong>Партийный номер:</strong> {item.batch_number}</p>
                                            <p><strong>Проект:</strong> {item.project}</p>
                                            <p><strong>Совместимость:</strong> {item.compatibility.join(', ')}</p>
                                        </div>
                                    )}
                                </li>
                            ))}
                        </ul>
                        <div className="mt-3 dashboard-order-actions">
                            <Button
                                variant="success"
                                onClick={() => handleCompleteOrder(selectedOrder.cartId, selectedOrder.details.user)}
                            >
                                Выдать заказ
                            </Button>
                            <Button
                                variant="danger"
                                className="ml-2"
                                onClick={() => handleDeleteOrder(selectedOrder.cartId)}
                            >
                                Удалить заказ
                            </Button>
                        </div>
                    </div>
                </div>
            ) : (
                orders.length > 0 ? (
                    orders.map((order) => (
                        <div key={order.order_id} className="mb-3 cart-componetn dashboard-summary-card">
                            <div className="card-body dashboard-summary-body">
                                <h5 className="card-title">Заказ #{order.order_id} от {order.created_at}</h5>
                                <p className="card-text">Пользователь: {order.user}</p>
                                {order.requires_rtcsd_ticket && (
                                    <p className="card-text">
                                        {order.rtcsd_is_cassette
                                            ? 'Hyosung кассета: RT CSD феномен не создается'
                                            : `RT CSD заявка: ${order.rtcsd_ticket_number || 'Не указана'}`}
                                    </p>
                                )}
                                <div className="d-flex dashboard-summary-actions">
                                    <Button
                                        variant="primary"
                                        onClick={() => fetchOrderDetails(order.order_id, order.user, order.status_label)}
                                    >
                                        Просмотреть детали
                                    </Button>
                                    <Button
                                        variant="danger"
                                        className="ml-2"
                                        onClick={() => handleDeleteOrder(order.order_id)}
                                    >
                                        Удалить заказ
                                    </Button>
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <p>Новых заказов нет</p>
                )
            )}

            {/* Модальное окно для показа изображения */}
            <Modal
                show={showImageModal}
                onHide={() => setShowImageModal(false)}
                centered
                className="warehouse-modal warehouse-media-modal"
                dialogClassName="warehouse-modal-dialog warehouse-modal-dialog--lg"
                contentClassName="warehouse-modal-content"
            >
                <Modal.Body>
                    <img src={modalImageSrc} alt="Просмотр изображения" style={{ width: '100%' }} />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowImageModal(false)}>Закрыть</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default StorekeeperDashboard;
